// @ts-nocheck
import React from "react";
import {useParams} from "react-router";
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import {PaddingDiv} from "./Home";

export default function Desuscripcion (){
    const {mensaje , severity} = useParams();
    
    return(
        <PaddingDiv>
            <Alert severity={severity}>
                <Typography variant="subtitle1" gutterBottom component="p">{mensaje}</Typography>
            </Alert>
        </PaddingDiv >
    )
}